import { Sprite } from '@pixi/react';
import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

import { gameStore } from '../../../store/gameStore';
import { freeBetStore } from '../../../store/freeBetStore';
import { bettingPartStore } from '../../../store/bettingPartStore';

import IconBackGround from '../../common/iconBackGround';

const AmountListIcon = observer(({ x = 0, y }) => {
  const { isSpinStart } = gameStore;
  const { isShowQuickBetsListPopup, setIsShowQuickBetsListPopup, isAutoBetStart } =
    bettingPartStore;
  const { quickBetsListIcon, closeAmountListIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  const handleOpenQuickBetList = useCallback(
    (e) => {
      e.stopPropagation();
      setIsShowQuickBetsListPopup(!isShowQuickBetsListPopup);
    },
    [isShowQuickBetsListPopup, setIsShowQuickBetsListPopup]
  );

  return (
    <IconBackGround
      y={y}
      x={x}
      handleSelect={handleOpenQuickBetList}
      isSelect={isShowQuickBetsListPopup}
      isDisabled={isSpinStart || isAutoBetStart || freeBetStore.currentFreeBet}
    >
      <Sprite
        texture={isShowQuickBetsListPopup ? closeAmountListIcon : quickBetsListIcon}
        anchor={0.5}
        scale={isMobile() ? 0.77 : 0.5}
      />
    </IconBackGround>
  );
});
export default AmountListIcon;
